<template>
  <div class="midologis-clone">
    <header :class="{ 'scrolled': isScrolled }">
      <div class="container header-content">
        <div class="logo">
          <img :src="require('@/assets/logo.png')" alt="(주) 엠테크 로고">
        </div>
        <nav class="desktop-nav">
          <ul>
            <li v-for="(item, index) in menuItems" :key="index" @click="scrollToSection(item.target)">
              {{ item.name }}
            </li>
          </ul>
        </nav>
        <div class="mobile-menu-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
          <span>☰</span>
        </div>
      </div>
      <div v-if="mobileMenuOpen" class="mobile-nav">
        <ul>
          <li v-for="(item, index) in menuItems" :key="index" @click="handleMobileClick(item.target)">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </header>

    <section class="main" :style="{backgroundImage: `url(${mainBackgroundImage})`}">
      <div class="main-overlay"></div>
      <div class="container main-content">
        <h2>고객을 위한 365일 서비스!</h2>
        <p>안녕하십니까. ㈜ 엠테크 홈페이지를 방문해 주셔서 감사드립니다.</p>
        <!-- <button class="btn-primary" @click="scrollToSection('contact')">문의하기 바로가기</button> -->
      </div>
    </section>

    <section id="greetings" class="section greetings">
      <div class="container">
        <h3 class="section-title">대표 인사말</h3>
        <div class="greetings-content">
          <p>
            당사는 <strong>끊임없는 서비스 정신과 노력</strong>을 바탕으로 <strong>최고의 고객만족감</strong>을 드리기 위해 항상 최선을 다하며,<br>
            물류 경험과 현장 노하우, 전문 인력 당일 배차로 원하는 시간 정성을 다하여 납품해 드리고 있습니다.<br><br>
            <strong>고객님의 이익 증대</strong>와 <strong>언제나 투명하고 성실한 자세</strong>로 기여할 것을 약속 드리며 많은 관심과 이용 부탁 드립니다.<br>
          </p>
          <div class="signature">- ㈜ 엠테크 대표 이무선 드림 -</div>
        </div>
      </div>
    </section>

    <section class="section ci-section">
      <div class="container">
        <h3>플라이애시, 아스팔트, 채움재 및 가설·토목·건축공사는 저희 ㈜ 엠테크를 찾아주십시오.</h3>
      </div>
    </section>

    <section id="company" class="section company-intro">
      <div class="container">
        <h3 class="section-title">㈜ 엠테크 소개</h3>
        <div class="greetings-content">
          <p>
            <strong>㈜ 엠테크</strong>는 2016년 8월 9일 창사 이후 <strong>플라이애시, 채움재</strong> 등 다양한 토목·건설 재료를 현장에 공급하고 있습니다.<br><br>
            <strong>플라이애시(Fly Ash)</strong>는 화력발전소에서 미분탄을 연소할 때 발생하는 분진을<br>집진 장치로 포집하여 얻는 미분말 입자로, 건축 및 토목 분야에서 활용되는 대표적인 친환경 순환 자원입니다.<br><br>
            해당 제품군의 <strong>특장점</strong>은 다음과 같습니다.<br><br>
            <strong><span class="points">
              • 콘크리트 원가절감<br>
              • 화학저항성 우수<br>
              • 장기강도 우수<br>
              • 알칼리 골재반응 억제<br>
              • 낮은 수화열<br>
              • 에너지 절약 및 환경친화적<br>
              • 작업성 우수<br>
            </span></strong><br><br>
            <strong>보령화력발전소</strong>에서 발생된 플라이애시는 정제공장인 <strong>㈜에이지시멘트</strong>에서 가공 처리된 후,<br><strong>KS L 5405 제08-0414호</strong> KS 인증을 받은 상태로 해당 정제공장을 통해 납품 받고 있습니다. 
          </p>
        </div>
      </div>

      <div class="container">
        <div class="carousel" @mouseenter="stopSlideTimer" @mouseleave="startSlideTimer">
          <button class="carousel-btn prev" @click="prevSlide">&lt;</button>
          <div class="carousel-track-container">
            <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
              <div class="carousel-slide" v-for="(img, index) in centerImages" :key="index">
                <div class="placeholder-image">
                  <img :src="img.url" :alt="img.name" style="width: 100%; height: 100%; object-fit: cover; border-radius: 10px;">
                </div>
                <p class="slide-caption">{{ img.name }}</p>
              </div>
            </div>
          </div>

          <button class="carousel-btn next" @click="nextSlide">&gt;</button>
        </div>
        <div class="carousel-indicators">
          <span 
            v-for="(img, idx) in centerImages" 
            :key="idx" 
            :class="{ active: currentSlide === idx }"
            @click="setSlide(idx)"
          ></span>
        </div>
      </div>
    </section>

    <section id="location" class="section location">
      <div class="container">
        <h3 class="section-title">오시는길</h3>
        <div class="location-grid">
          <div class="info-box">
            <div class="info-item">
              <strong>📍 주소</strong>
              <p>충남 보령시 청룡굴길 18</p>
            </div>
            <div class="info-item">
              <strong>📞 대표번호</strong>
              <p>T. 041-935-5839 | F. 041-936-5589</p>
            </div>
            <div class="info-item">
              <strong>✉️ 이메일</strong>
              <p>lms884@naver.com</p>
            </div>
            <div class="info-item">
              <strong>🕐 운영시간</strong>
              <p>08:30 ~ 17:30 (토·일·공휴일 휴무)</p>
            </div>
          </div>
          <div class="map-box" :style="{ backgroundImage: `url(${mapPlaceholder})` }">
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="history" class="section history">
      <div class="container">
        <h3 class="section-title">연혁</h3>
        <div class="timeline">
          <div class="timeline-item" v-for="(item, index) in historyItems" :key="index">
            <div class="year">{{ item.year }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="business" class="section business">
      <div class="container">
        <h3 class="section-title">사업소개</h3>
        <p class="business-desc">귀찮고 번거로운 물류업무, 고객님들의 핵심업무에 집중할 수 있도록 미도로지스에서 다 하겠습니다.</p>
        <div class="process-flow">
          <div class="process-step" v-for="(step, index) in businessSteps" :key="index">
            <div class="circle">{{ step }}</div>
            <div v-if="index < businessSteps.length - 1" class="arrow">→</div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="wms" class="section wms">
      <div class="container">
        <h3 class="section-title">WMS (물류관리시스템)</h3>
        <p>미도로지스의 WMS는 고객님의 물류정보를 체계적으로 실시간 연동·관리·제공합니다.</p>
        <button class="btn-secondary">WMS 접속하기</button>
      </div>
    </section> -->

    <!-- <section id="contact" class="section contact">
      <div class="container">
        <h3 class="section-title">문의하기</h3>
        <p class="contact-desc">문의하기를 남겨주시면 상세한 정보를 답변해드리겠습니다.</p>
        
        <form @submit.prevent="submitForm" class="contact-form">
          <div class="form-row">
            <div class="form-group half">
              <label>담당자명 *</label>
              <input type="text" v-model="form.name" required>
            </div>
            <div class="form-group half">
              <label>이메일 주소 *</label>
              <input type="email" v-model="form.email" required placeholder="회신 받으실 이메일">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>회사명 (부서명) *</label>
              <input type="text" v-model="form.company" required>
            </div>
            <div class="form-group half">
              <label>연락처 *</label>
              <input type="tel" v-model="form.phone" required>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>취급품목</label>
              <input type="text" v-model="form.product">
            </div>
            <div class="form-group half">
              <label>품목수 (SKU)</label>
              <input type="text" v-model="form.sku">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>필요한 보관공간 (평)</label>
              <input type="text" v-model="form.space">
            </div>
            <div class="form-group half">
              <label>월평균 택배건수</label>
              <input type="text" v-model="form.volume">
            </div>
          </div>
          
          <div class="form-group">
            <label>문의내용 *</label>
            <textarea v-model="form.message" rows="5" required></textarea>
          </div>

          <div class="form-group checkbox-group">
            <input type="checkbox" id="privacy" v-model="form.privacy" required>
            <label for="privacy">개인정보 처리방침에 동의합니다.</label>
          </div>

          <button type="submit" class="btn-submit">접수하기</button>
        </form>
      </div>
    </section> -->

    <footer>
      <div class="container">
        <div class="footer-info">
          <p><strong>㈜ 엠테크</strong></p>
          <p>주소: 충남 보령시 청룡굴길 18 | 대표자명: 이무선</p>
          <p>Tel: 041-935-5839 | Fax: 041-936-5589</p>
          <p>E-mail: lms884@naver.com</p>
        </div>
        <!-- <div class="copyright">
          COPYRIGHT ©MIDO LOGIS All rights reserved.
        </div> -->
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import mainBackgroundImage from '@/assets/main-background-image.png';
import mapPlaceholder from '@/assets/map-placeholder.png';


// --- Navigation Logic ---
const isScrolled = ref(false);
const mobileMenuOpen = ref(false);

const menuItems = [
  { name: '인사말', target: 'greetings' }, // Greetings, Center, History, Location 포함
  { name: '회사소개', target: 'company' },
  { name: '오시는길', target: 'location' },
];

const handleScroll = () => {
  isScrolled.value = window.scrollY > window.innerHeight - 80;
};

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    const headerOffset = 78;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
};

const handleMobileClick = (id) => {
  scrollToSection(id);
  mobileMenuOpen.value = false;
};

// --- Carousel Logic (Center Intro) ---
const currentSlide = ref(0);
const centerImages = [
  { name: '화력발전소 사진 1', url: require('@/assets/slide1.jpeg') },
  { name: '화력발전소 사진 2', url: require('@/assets/slide2.jpeg') },
  { name: '정제공장 사진 1', url: require('@/assets/slide3.jpeg') },
  { name: '정제공장 사진 2', url: require('@/assets/slide4.jpeg') },
  { name: '운송 차량', url: require('@/assets/slide5.jpeg') },
  { name: '납품 현장', url: require('@/assets/slide6.jpeg') }
];

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % centerImages.length;
  resetSlideTimer();
};

const prevSlide = () => {
  currentSlide.value = (currentSlide.value - 1 + centerImages.length) % centerImages.length;
  resetSlideTimer();
};

let slideInterval = null;

const startSlideTimer = () => {
  stopSlideTimer();
  slideInterval = setInterval(() => {
    // Timer fires nextSlide but without resetting the timer recursively (which nextSlide does)
    // Actually nextSlide resets timer, so that's fine.
    currentSlide.value = (currentSlide.value + 1) % centerImages.length;
  }, 5000);
};

const stopSlideTimer = () => {
  if (slideInterval) {
    clearInterval(slideInterval);
    slideInterval = null;
  }
};

const resetSlideTimer = () => {
  stopSlideTimer();
  startSlideTimer();
};

const setSlide = (idx) => {
  currentSlide.value = idx;
  resetSlideTimer();
};

// --- History Data ---
const historyItems = [
  { year: '2025', desc: '“3PL 전문기업” 미도로지스 설립' },
  { year: '2023', desc: 'Fabric 관련 물류업 시행' },
  { year: '1999 ~', desc: 'ATY Yarn 생산 프로세스 도입, 향토뿌리기업 등록' },
  { year: '1997', desc: '수출 1,000만 달러 달성' },
  { year: '1980', desc: '서울 영업사무소 설립' },
  { year: '1965', desc: '㈜미광 설립' },
];

// --- Business Steps ---
const businessSteps = [
  '입고', '검수/적치', '보관', '주문취합', '피킹/패킹', '출고', '반품관리'
];

// --- Contact Form ---
const form = ref({
  name: '',
  email: '',
  company: '',
  phone: '',
  product: '',
  sku: '',
  space: '',
  volume: '',
  message: '',
  privacy: false
});

const submitForm = () => {
  if (!form.value.privacy) {
    alert('개인정보 처리방침에 동의해주세요.');
    return;
  }
  alert('문의가 접수되었습니다. (데모 기능)');
  // 실제로는 백엔드 API 호출
  console.log('Form Submitted:', form.value);
};

// --- Lifecycle Hooks ---
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  startSlideTimer();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  stopSlideTimer();
});
</script>

<style scoped>
/* Reset & Base Styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Pretendard Variable", "Pretendard", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;
}

body {
  color: #333;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 90px 0;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 50px;
  color: #1E1E92; /* Assuming brand color */
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: #1E1E92;
  margin: 20px auto 0;
}

/* Header */
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: transparent;
  z-index: 1000;
  transition: background 0.3s, box-shadow 0.3s;
  color: #fff;
}

header.scrolled {
  background: #fff;
  color: #333;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.logo img {
  height: 80px;
  object-fit: contain;
}

/* .logo h1 {
  font-size: 1.5rem;
  font-weight: bold;
} */

.desktop-nav ul {
  display: flex;
  list-style: none;
  gap: 30px;
}

.desktop-nav li {
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s;
}

.desktop-nav li:hover {
  color: #1E1E92;
}

.mobile-menu-toggle {
  display: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-nav {
  background: #fff;
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0,0,0,0.1);
}

.mobile-nav ul {
  list-style: none;
  padding: 20px;
}

.mobile-nav li {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  color: #333;
  cursor: pointer;
}

/* main Section */
.main {
  position: relative;
  height: calc(100vh);
  background: url('https://via.placeholder.com/1920x600?text=Logistics+main+Image') no-repeat center/cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}

.main-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.main-content {
  position: relative;
  z-index: 1;
}

.main-content * {
  text-shadow: 0 0 4px #000000;
}

.main h2 {
  font-size: 3rem;
  margin-bottom: 20px;
  line-height: 1.3;
}

.main p {
  font-size: 1.5rem;
  margin-bottom: 40px;
}

.btn-primary {
  background: #1E1E92;
  color: #fff;
  border: none;
  padding: 15px 40px;
  font-size: 1.2rem;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.3s;
}

.btn-primary:hover {
  background: #1E1E92;
}

/* Greetings */
.greetings {
  background: #f9f9f9;
  padding: 260px 0;
}

.greetings-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.greetings-content p {
  font-size: 1.2rem;
  color: #000000;
  margin-bottom: 30px;
}

.greetings-content .points {
  display: inline-block;
  width: auto;
  text-align: left;
}

.signature {
  font-weight: bold;
  font-size: 1.2rem;
}

/* CI Section */
.ci-section {
  background: #1E1E92;
  color: #fff;
  text-align: center;
  padding: 60px 0;
}

.ci-section h3 {
  font-size: 1.8rem;
}

/* Center Carousel */
.carousel {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  border-radius: 10px;
  /* overflow hidden relies on track-container now, but keeping relative positioning here is good */
}

.carousel-track-container {
  overflow: hidden;
  width: 100%;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
}

.carousel-slide {
  min-width: 100%;
  text-align: center;
}

.placeholder-image {
  width: 100%;
  height: 500px;
  background: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #777;
}

.slide-caption {
  margin-top: 15px;
  font-weight: bold;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  color: #fff;
  border: none;
  padding: 15px;
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 10;
}

.carousel-btn.prev { left: 10px; }
.carousel-btn.next { right: 10px; }

.carousel-indicators {
  text-align: center;
  margin-top: 20px;
}

.carousel-indicators span {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #ccc;
  margin: 0 5px;
  border-radius: 50%;
  cursor: pointer;
}

.carousel-indicators span.active {
  background: #1a3c74;
}

/* History */
.timeline {
  max-width: 800px;
  margin: 0 auto;
  border-left: 2px solid #ddd;
  padding-left: 40px;
}

.timeline-item {
  position: relative;
  margin-bottom: 40px;
}

.timeline-item::before {
  content: '';
  position: absolute;
  left: -49px;
  top: 5px;
  width: 16px;
  height: 16px;
  background: #1E1E92;
  border-radius: 50%;
  border: 4px solid #fff;
  box-shadow: 0 0 0 2px #ddd;
}

.timeline-item .year {
  font-size: 1.2rem;
  font-weight: bold;
  color: #1E1E92;
  margin-bottom: 5px;
}

/* Location */
.location-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.map-box {
  min-height: 400px;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.info-item {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.info-item strong {
  display: block;
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #1E1E92;
}

/* Business Steps */
.process-flow {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 50px;
}

.process-step {
  display: flex;
  align-items: center;
}

.circle {
  width: 120px;
  height: 120px;
  background: #fff;
  border: 2px solid #1E1E92;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: #1E1E92;
  transition: all 0.3s;
}

.circle:hover {
  background: #1E1E92;
  color: #fff;
}

.arrow {
  margin: 0 15px;
  font-size: 1.5rem;
  color: #ccc;
}

.business-desc {
  text-align: center;
  font-size: 1.2rem;
}

/* WMS */
.wms {
  background: #e9f2ff;
  text-align: center;
}

.wms p {
  font-size: 1.2rem;
  margin-bottom: 30px;
}

.btn-secondary {
  background: transparent;
  border: 2px solid #1E1E92;
  color: #1E1E92;
  padding: 10px 30px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s;
}

.btn-secondary:hover {
  background: #1E1E92;
  color: #fff;
}

/* Contact Form */
.contact-form {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  padding: 40px;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
}

.contact-desc {
  text-align: center;
  margin-bottom: 40px;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group.half {
  flex: 1;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.checkbox-group input {
  width: auto;
}

.btn-submit {
  width: 100%;
  background: #1E1E92;
  color: #fff;
  border: none;
  padding: 15px;
  font-size: 1.2rem;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}

/* Footer */
footer {
  background: #333;
  color: #aaa;
  padding: 50px 0;
  text-align: center;
  font-size: 0.9rem;
}

.footer-info p {
  margin-bottom: 10px;
}

.footer-info strong {
  color: #fff;
  font-size: 1.2rem;
}

.copyright {
  margin-top: 30px;
  border-top: 1px solid #444;
  padding-top: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .desktop-nav {
    display: none;
  }
  .mobile-menu-toggle {
    display: block;
  }
  .header-content {
    padding: 0 20px;
  }
  .main h2 {
    font-size: 2rem;
  }
  .location-grid,
  .form-row {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .arrow {
    display: none; /* Hide arrows on mobile for stacked layout */
  }
  .process-step {
    flex-direction: column;
    margin-bottom: 20px;
  }
}
</style>